import { render, staticRenderFns } from "./CardImgsOP.vue?vue&type=template&id=1a2f1a11&scoped=true&"
import script from "./CardImgsOP.vue?vue&type=script&lang=js&"
export * from "./CardImgsOP.vue?vue&type=script&lang=js&"
import style0 from "./CardImgsOP.vue?vue&type=style&index=0&id=1a2f1a11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2f1a11",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCarousel,VCarouselItem,VCol,VContainer,VRow})
